import React from 'react';
import { PermissionsCheck } from '../../Components/Auth/PermissionsCheck';
import { Button, ButtonSize } from '../../Components/Button';
import { PlusIcon } from '../../Components/Icons';
import MedicationListNotFound from '../../Images/medicationListNotFound.svg';
import MedicationsNotFound from '../../Images/medicationsNotFound.svg';
import { MedicationsPermissions } from '../../MedicationsPermissions';
import { white } from '../../Styles/Colours';
import styles from './MedicationListErrors.module.scss';

export const MedicationListErrors = (props: {
    hasQuery: boolean;
    hasEntries: boolean;
    hasPublished: boolean;
    onAddAction(): void;
}) => {
    if (props.hasEntries) return null;

    const graphic = props.hasQuery ? (
        <img src={MedicationsNotFound} alt='' />
    ) : (
        <img src={MedicationListNotFound} alt='' />
    );

    const text = props.hasQuery ? (
        <span>
            No medications found.
            <br />
            Refine your search and try again.
        </span>
    ) : (
        <span>
            No medication list items found.
            <br />
            Create a medication list.
        </span>
    );

    const actionButton = !props.hasQuery && !props.hasPublished && (
        <PermissionsCheck permission={MedicationsPermissions.WriteMedicationLists}>
            <div className={styles.buttonContainer}>
                <Button
                    testId='add-medication-list'
                    startIcon={<PlusIcon color={white} />}
                    size={ButtonSize.medium}
                    onClick={props.onAddAction}
                >
                    Add medication list
                </Button>
            </div>
        </PermissionsCheck>
    );

    return (
        <div className={styles.container}>
            <div className={styles.placeholder}>
                <div className={styles.placeholderContent}>
                    {graphic}
                    <div className={styles.placeholderTitleText}>{text}</div>
                    {actionButton}
                </div>
            </div>
        </div>
    );
};
